import React from 'react';

import { useIntl } from 'react-intl-next';

import ShowMoreIcon from '@atlaskit/icon/core/align-text-left';
import { RequestStatus } from '@atlassian/navigation-bff-data-provider';

import type { GlobalShortcutsProps, ViewAllAppsConfig } from '../../types';
import { ShortcutMenuItem } from '../shortcut-menu-item';

import { messages } from './messages';

export type ViewAllAppsItemProps = Pick<GlobalShortcutsProps, 'product'> &
	ViewAllAppsConfig & {
		/**
		 * The status of the BFF request of the parent component.
		 */
		status?: RequestStatus | null;
	};

export function ViewAllAppsItem({
	path,
	isSelected,
	product,
	onNavigate,
	status = RequestStatus.INIT,
}: ViewAllAppsItemProps) {
	const { formatMessage } = useIntl();
	const analyticsName = 'VIEW_ALL_APPS';

	if (!path || path.trim().length < 1) {
		return null;
	}

	return (
		<ShortcutMenuItem
			shortcut={{
				key: analyticsName,
				analyticsName: analyticsName,
				label: formatMessage(messages.viewAllAppsLabel),
				icon: <ShowMoreIcon label="" />,
				url: path,
				isReorderable: false,
				type: 'internal',
				isSelected: isSelected,
				onClick: onNavigate,
			}}
			product={product}
			// Do not disable the link if the parent component has a BFF error
			// while handling init/loading states the same as other shortcuts
			// (Using forceStatic for this without replacing error state with complete state would cause the link to be disabled)
			status={status === RequestStatus.ERROR ? RequestStatus.COMPLETE : status}
		/>
	);
}
